import React from 'react';
import { Droplets, Filter, Zap, Shield } from 'lucide-react';
import { propertyData } from '../../data/mock';

const ResilienceSection = () => {
  const resilienceIcons = {
    "Established Well Water": Droplets,
    "Whole-Home Water Filtration & Treatment": Filter,
    "Whole-Home Propane Generac Generator": Zap,
    "Newer Metal Roofing System": Shield,
  };

  return (
    <section className="py-24 bg-gradient-to-b from-[#0a0c10] to-[#0d1117]" data-testid="resilience-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 bg-amber-500/10 border border-amber-500/30 rounded-full text-amber-400 text-sm font-medium tracking-wide mb-4">
            Preparedness Infrastructure
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-white mb-6">
            BUILT WITH FLORIDA RESILIENCE IN MIND
          </h2>
          <p className="text-lg text-white/70 font-light">
            Meaningful preparedness infrastructure is already part of the estate.
          </p>
        </div>

        {/* Resilience Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {propertyData.resilienceFeatures.map((feature) => {
            const Icon = resilienceIcons[feature.title] || Shield;
            const featureKey = feature.title.toLowerCase().replace(/\s+/g, '-');
            return (
              <div
                key={featureKey}
                className="group relative bg-gradient-to-br from-white/5 to-white/[0.02] border border-white/10 rounded-2xl p-8 hover:border-amber-500/40 transition-all duration-500"
              >
                <div className="absolute top-0 right-0 w-24 h-24 bg-amber-500/5 rounded-full blur-2xl group-hover:bg-amber-500/10 transition-all duration-500" />
                <div className="relative">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500/20 to-amber-600/20 border border-amber-500/30 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-amber-400" />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-3 uppercase tracking-wide">
                    {feature.title}
                  </h3>
                  <p className="text-white/60 font-light text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Supporting Statement */}
        <div className="mt-12 text-center">
          <p className="text-white/50 text-sm max-w-2xl mx-auto">
            These systems provide meaningful independence and peace of mind. 
            The estate does not claim to be disaster-proof, hurricane-proof, or storm-proof, 
            but offers substantial preparedness infrastructure already in place.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ResilienceSection;
